module.exports = __webpack_public_path__ + "img/reset.c9115ce6.svg";